module.exports = __webpack_public_path__ + "img/172.b8da697a.jpg";